import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function availableServicesReducer(
  state = initialState.availableServices,
  action
) {
  switch (action.type) {
    case types.LOAD_AVAILABLE_SERVICES_SUCCESS:
      return action.availableServices;
    case types.RESET_AVAILABLE_SERVICES_SUCCESS:
      return initialState.availableServices;
    default:
      return state;
  }
}
